import * as CONST from './constants';

function applicantOriginLabel(that, origin, referral) {
  let origin_msg;

  switch (origin) {
    case CONST.ORIGIN_APPLY:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originForm'
      });
      break;
    case CONST.ORIGIN_MAILIN:
      if (referral) {
        origin_msg = that.props.intl.formatMessage({
          id: 'ChipOrigin.originReferral'
        });
      } else {
        origin_msg = that.props.intl.formatMessage({
          id: 'ChipOrigin.originMail'
        });
      }
      break;
    case CONST.ORIGIN_IMPORT:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originImport'
      });
      break;
    case CONST.ORIGIN_HUNT:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originHunting'
      });
      break;
    case CONST.ORIGIN_SCRAP:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originScrap'
      });
      break;
    case CONST.ORIGIN_SEARCH:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originSearch'
      });
      break;
    case CONST.ORIGIN_MOVE:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originMove'
      });
      break;
    case CONST.ORIGIN_COPY:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originCopy'
      });
      break;
    case CONST.ORIGIN_CROSSRANK:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originCrossrank'
      });
      break;
    case CONST.ORIGIN_RECRUITER:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originRecruiter'
      });
      break;
    default:
      origin_msg = that.props.intl.formatMessage({
        id: 'ChipOrigin.originUnknown'
      });
  }
  return origin_msg;
}

export default applicantOriginLabel;
